import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import {AccountDetailService} from './services/account/account-detail.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'HechRomeoGuide';
  constructor(private translate: TranslateService, private accountDetailService: AccountDetailService) {
    translate.setDefaultLang('en');
    let localLanguage = navigator.language.slice(0, -3);
    if (
      environment.languagesTranslate.find((obj) => obj == localLanguage) ==
      undefined
    ) {
      localLanguage = environment.defaultLanguage;
    }
    if (localStorage.getItem('language')) {
      translate.use(localStorage.getItem('language'));
    } else {
      translate.use(localLanguage);
      localStorage.setItem('language', localLanguage);
    }

    this.accountDetailService.setAccount(localStorage.getItem('HechRomeoAccount'));
  }
}
